/**
 * Bridges the notification-bell unread count (local state inside NotificationIcon)
 * out to a global place, so the app-icon badge hook can combine it with the chat
 * unread total from chatStore. Chat unread already lives in a global store; this
 * only needs to carry the notifications number.
 */
import { create } from 'zustand';

export const useBadgeStore = create((set) => ({
  notifUnread: 0,
  setNotifUnread: (n) => set({ notifUnread: Math.max(0, n | 0) }),
}));
